<vdr-page-body>
  <form
    class="form"
    [formGroup]="detailForm"
    (ngSubmit)="save()"
  >
    <vdr-page-block>
      <vdr-action-bar>
        <vdr-ab-right>
          <button
            *vdrIfPermissions="'UpdateBaseProduct'"
            id="submit"
            type="submit"
            class="button primary"
            [disabled]="hideSubmit()"
          >
            {{ (entity ? 'common.update' : 'common.create') | translate }}
          </button>
        </vdr-ab-right>
      </vdr-action-bar>
    </vdr-page-block>
  </form>
</vdr-page-body>
<vdr-page-detail-layout>
  <vdr-page-detail-sidebar>
    <vdr-card title="Imagem">
      <image-picker-list
        (asset)="onAsset($event)"
        (onHttpRequest)="(onHttpRequest)"
        [assets]="entity ? [entity.asset] : []"
        (multiselect)="(false)"
      ></image-picker-list>
    </vdr-card>
    <vdr-card [title]="'catalog.facets' | translate">
      <div class="facets">
        <vdr-facet-value-chip
          *ngFor="let facetValue of facetValues$ | async"
          [facetValue]="facetValue"
          [removable]="updatePermissions | hasPermission"
          (remove)="removeProductFacetValue(facetValue.id)"
        ></vdr-facet-value-chip>
      </div>
      <div>
        <button
          class="button-small mt-2"
          (click)="selectFacetValue()"
        >
          <clr-icon shape="plus"></clr-icon>
          {{ 'catalog.add-facets' | translate }}
        </button>
      </div>
    </vdr-card>
    <vdr-card
      title="Detalhes"
      *ngIf="entity"
    >
      <vdr-page-entity-info [entity]="entity" />
    </vdr-card>
  </vdr-page-detail-sidebar>
  <vdr-page-block>
    <vdr-card title="Detalhes">
      <form
        class="form"
        [formGroup]="detailForm"
      >
        <div class="form-grid">
          <vdr-form-field
            [label]="'catalog.name' | translate"
            for="name"
          >
            <input
              id="name"
              type="text"
              formControlName="name"
              [readonly]="!(updatePermissions | hasPermission)"
            />
          </vdr-form-field>
          <vdr-form-field
            [label]="'catalog.size' | translate"
            for="size"
          >
            <input
              id="size"
              type="number"
              formControlName="size"
              [readonly]="!(updatePermissions | hasPermission)"
            />
          </vdr-form-field>
          <vdr-form-field
            [label]="'catalog.weight' | translate"
            for="weight"
          >
            <input
              id="weight"
              type="number"
              formControlName="weight"
              [readonly]="!(updatePermissions | hasPermission)"
            />
          </vdr-form-field>
          <vdr-form-field
            [label]="'catalog.price' | translate"
            for="price"
          >
            <input
              id="price"
              type="number"
              formControlName="price"
              [readonly]="!(updatePermissions | hasPermission)"
            />
          </vdr-form-field>
        </div>
      </form>
    </vdr-card>
    <vdr-card
      title="Variantes"
      *ngIf="entity"
    >
      <ng-container>
        <base-product-selected [id]="entity.id"></base-product-selected>
      </ng-container>
    </vdr-card>
  </vdr-page-block>
</vdr-page-detail-layout>
